import { Button } from "antd";
import { deliveryStatus } from "../../constants/others";
import { openNotification } from "../../helpers/alerts";
import { updateData } from "../../helpers/api";
import SelectInput from "../inputs/SelectInput";
import TextInput from "../inputs/TextInput";
import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from 'yup';

const initialValues = {
    deliveryStatus: null,
    note: ""
}
const UpdateDeliveryStatus = (props) => {
    const {handelAfterAddingNote, isModalOpen, handleCancel, orderId } = props
    const updateDeliveryStatus = async (values, submitProps) => {
        try {
            await updateData(`/orders/deliveryman/${orderId}`, {
                note: values.note,
                deliveryStatus: values.deliveryStatus
            })
            openNotification(`Le statut de la livraison a été mis a jour avec succès`, 'success')
            submitProps.resetForm()
            handelAfterAddingNote()
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    return (
        <AddElementLayout
            title="Mis a jour le statut de la cammande"
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={initialValues}
            validationSchema={
                Yup.object({
                    deliveryStatus: Yup.string().required('required'),
                    note: Yup.string().optional(),
                })
            }
            handleSubmitForm={(values, submitProps) => {
                updateDeliveryStatus(values, submitProps)
            }}
        >

            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: 10
            }}>
                <SelectInput
                    name="deliveryStatus"
                    size="large"
                    placeholder={"Statut"}
                    options={deliveryStatus.map((el) => ({ value: el, label: el }))}
                />
                <TextInput
                    name="note"
                    placeholder="Note"
                    size="large"
                />
                <Button size='large' type="primary" htmlType="submit">
                    Mis a jour le statut de la cammande
                </Button>
            </div>

        </AddElementLayout>
    );
}

export default UpdateDeliveryStatus;